import { useQuery } from '@tanstack/react-query';
import { integrationsApi } from '../api/endpoints/integrations';

export const integrationsKey = (tenantId: string) =>
    ['platform', 'tenants', tenantId, 'integrations'] as const;

export const integrationKeysKey = (tenantId: string, integrationId: string) =>
    ['platform', 'tenants', tenantId, 'integrations', integrationId, 'keys'] as const;

// El secreto de una llave NO tiene query: se devuelve una sola vez en el POST que la emite y
// cachearlo lo dejaría vivo en memoria del navegador.
export function useIntegrations(tenantId: string) {
    return useQuery({
        queryKey: integrationsKey(tenantId),
        queryFn: () => integrationsApi.list(tenantId),
        enabled: !!tenantId,
    });
}

export function useIntegrationKeys(tenantId: string, integrationId: string | undefined) {
    return useQuery({
        queryKey: integrationKeysKey(tenantId, integrationId ?? ''),
        queryFn: () => integrationsApi.listKeys(tenantId, integrationId as string),
        enabled: !!tenantId && !!integrationId,
    });
}
